import { options } from "./options";
import { series } from "./series";

export const apex = {
  options,
  series,
};
